import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEO = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Définir la langue du document
    document.documentElement.lang = i18n.language;

    // Meta tags de base
    const metaTags = {
      fr: {
        title: 'Creation de sites web professionnels | WebCaliskan',
        description: 'WebCaliskan cree des sites vitrines, e-commerce et applications web sur mesure. Devis gratuit sous 24h.',
        keywords: 'creation site web, site vitrine, ecommerce, application web, devis site internet, agence web',
        ogTitle: 'Creation de sites web professionnels | WebCaliskan',
        ogDescription: 'Site vitrine, e-commerce et applications web sur mesure. Devis gratuit sous 24h.'
      },
      en: {
        title: 'Professional website creation | WebCaliskan',
        description: 'WebCaliskan builds showcase websites, ecommerce stores and custom web apps. Free quote in 24h.',
        keywords: 'website creation, showcase site, ecommerce, web application, website quote',
        ogTitle: 'Professional website creation | WebCaliskan',
        ogDescription: 'Showcase websites, ecommerce and custom web applications. Free quote in 24h.'
      },
      tr: {
        title: 'Profesyonel web sitesi olusturma | WebCaliskan',
        description: 'WebCaliskan tanitim sitesi, e-ticaret ve ozel web uygulamalari gelistirir. 24 saatte ucretsiz teklif.',
        keywords: 'web sitesi olusturma, e ticaret, web uygulamasi, web teklif',
        ogTitle: 'Profesyonel web sitesi olusturma | WebCaliskan',
        ogDescription: 'Tanitim sitesi, e-ticaret ve ozel web uygulamalari. 24 saatte ucretsiz teklif.'
      },
      nl: {
        title: 'Professionele website ontwikkeling | WebCaliskan',
        description: 'WebCaliskan bouwt showcase sites, e-commerce en maatwerk webapps. Gratis offerte binnen 24 uur.',
        keywords: 'website ontwikkeling, showcase site, e commerce, webapp, offerte website',
        ogTitle: 'Professionele website ontwikkeling | WebCaliskan',
        ogDescription: 'Showcase site, e-commerce en maatwerk webapplicaties. Gratis offerte binnen 24 uur.'
      }
    };

    const currentLang = i18n.language || 'fr';
    const meta = metaTags[currentLang] || metaTags.fr;
    const siteUrl = 'https://webcaliskan.fr';

    // Mettre à jour le titre
    document.title = meta.title;

    // Mettre à jour ou créer les meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Meta tags standard
    updateMeta('description', meta.description);
    updateMeta('keywords', meta.keywords);
    updateMeta('author', 'WebCaliskan - Halil Can Caliskan');
    updateMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    
    // Open Graph
    updateMeta('og:title', meta.ogTitle, true);
    updateMeta('og:description', meta.ogDescription, true);
    updateMeta('og:type', 'website', true);
    updateMeta('og:url', `${siteUrl}/`, true);
    updateMeta('og:site_name', 'WebCaliskan', true);
    updateMeta('og:locale', currentLang === 'fr' ? 'fr_FR' : currentLang === 'en' ? 'en_US' : currentLang === 'tr' ? 'tr_TR' : 'nl_NL', true);
    
    // Twitter Card
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', meta.ogTitle);
    updateMeta('twitter:description', meta.ogDescription);
    
    // Mobile
    updateMeta('viewport', 'width=device-width, initial-scale=1.0, maximum-scale=5.0');
    updateMeta('theme-color', '#2196f3');
    
    // Structured Data (JSON-LD)
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      'name': 'WebCaliskan',
      'url': `${siteUrl}/`,
      'description': meta.description,
      'image': `${siteUrl}/logo512.png`,
      'telephone': '+33-6-49-87-62-36',
      'email': 'webcaliskan@gmail.com',
      'priceRange': 'EUR',
      'address': {
        '@type': 'PostalAddress',
        'addressCountry': 'FR'
      }
    };

    // Ajouter ou mettre à jour le script JSON-LD
    let script = document.querySelector('script[data-seo-jsonld="localbusiness"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'localbusiness');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);

  }, [i18n.language]);

  return null; // Ce composant ne rend rien visuellement
};

export default SEO;
